import(/* webpackMode: "eager" */ "/Users/viper/code/sms/src/app/error.tsx");
